// eslint-disable-next-line import/namespace, import/no-named-as-default-member, import/no-named-as-default, import/default
import screenfull from "screenfull"
import { useEffect } from "react"

import ButtonIcon from "./ButtonIcon"
import { useToggle } from "../hooks"

const FullscreenButton = ({ isVisible = true }) => {
  const [isFullscreen, toggleFullscreen] = useToggle(screenfull.isFullscreen || false)

  const handleFullsceen = () => {
    if (screenfull.isEnabled) {
      screenfull.toggle(undefined, { navigationUI: "hide" })
    }
  }

  useEffect(() => {
    const onChangeHandler = () => toggleFullscreen(screenfull.isFullscreen)

    if (screenfull.isEnabled) {
      screenfull.on("change", onChangeHandler)
    }
    return () => {
      return screenfull.off("change", onChangeHandler)
    }
  }, [toggleFullscreen])

  return (
    <ButtonIcon
      iconName={isFullscreen ? "IconFullscreenExit" : "IconFullscreenEnter"}
      isVisible={isVisible && screenfull.isEnabled}
      onClick={handleFullsceen}
    />
  )
}

export default FullscreenButton
